import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import './../../util';
import {InputDirective} from '../../input/input.directive';
import {UserAnswerMode} from '../../model/user-answer.mode';
import {QuestionInfo} from '../../model/question.model';
import {FIELD_TYPES} from "../../config/fieldTypes.config";
import {ChatQuestionsService} from "../../service/chat/chat-questions.service";

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @ViewChild(InputDirective, {static: true})
  inputField: InputDirective;


  @Input()
  question;

  @Output()
  submitted = new EventEmitter<UserAnswerMode>();

  public hasAnswer: boolean;
  public inputValid: boolean;

  constructor(private chatQuestionsService: ChatQuestionsService) {

  }

  ngOnInit() {

  }


  goNext() {
    console.log(this.question, this.inputField, 'done')
    // if(this.inputField.answer != "" && this.inputField.answer != '0' && this.checkAnswerLengthIsEnough()){
    if(this.inputField.answer != "" && this.inputField.answer != '0'){
        const answerTitle = this.question.fieldType === FIELD_TYPES.number ? this.inputField.answer.replace(/\s/g, '') : this.inputField.answer;

        const answer = this.chatQuestionsService.generateAnswer(this.question, answerTitle);
        this.submitted.emit(answer);
        this.inputValid = false;
    }
  }


  checkAnswerLengthIsEnough() {
    const requiredLength = this.question.answerLength;
    const currentAnswerLength = this.inputField.answer.length;
    const isFieldTypeNumber = this.questionType === FIELD_TYPES.number;

    return isFieldTypeNumber ? !requiredLength || requiredLength === currentAnswerLength : true;
  }

  canGoNext() {
    return this.hasAnswer;
  }

  answered(event: boolean) {

    this.hasAnswer = event;
    // this.inputValid = this.hasAnswer && this.inputField.answer != "" && this.checkAnswerLengthIsEnough();
    this.inputValid = this.hasAnswer && this.inputField.answer != "";


    if (event && this.questionType === 'RADIO_GROUP') {
      this.goNext();
      this.hasAnswer = false;
    }
  }

  getAnswerTypeClass() {
    return {
      'answer--radio-group': this.questionType === FIELD_TYPES.radio,
      'answer--date': this.questionType === FIELD_TYPES.date,
      'answer--date answer--date-range': this.questionType === FIELD_TYPES.dateRange,
      'answer--select': this.questionType === FIELD_TYPES.select,
      'answer--textarea': this.questionType === FIELD_TYPES.textarea,
    }
  }

  get questionType() {
    if (this.question) {
      return this.question.fieldType;
    }
  }

  get questionParentType() {
    if (this.question && this.question.parentFieldType) {
      return this.question.parentFieldType;
    }
  }

  test($event) {
    console.log('test');
    console.log($event);
  }

}
